import React, {useState, useContext} from "react";
import {
    MDBBtn,
    MDBModal,
    MDBModalDialog,
    MDBModalContent,
    MDBModalHeader,
    MDBModalTitle,
    MDBModalBody,
    MDBModalFooter,
    MDBInput,
} from "@krtrimaiq-cognitive-solutions/mdb-react-ui-kit";
import {useNavigate} from "react-router-dom";
import {useMDBCookies} from '@krtrimaiq-cognitive-solutions/mdb-react-cookies-management';
import {UrlContext} from "../../App";
import axios from "axios";

function Login() {
    const {setItem: setUserId} = useMDBCookies('user-id', '')[1];
    const {setItem: setUserType} = useMDBCookies('user-type', '')[1];
    const {setItem: setUserFirstName} = useMDBCookies('user-firstname', '')[1];
    const {setItem: setUserLastName} = useMDBCookies('user-lastname', '')[1];
    const {isLogin, setLogin} = useContext(UrlContext);
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [message, setMessage] = useState("");

    // handle button click of login form
    async function handleLogin() {
        setMessage("")
        axios.post(
            "https://x20sfr8b51.execute-api.ap-south-1.amazonaws.com/mapmyclasses/login",
            JSON.stringify({emailId: email, password: password}),
            {validateStatus: false}
        )
            .then(response => {
                if (response.status === 200) {
                    setUserId(response.data['_id']['$oid'], {expires: 1});
                    setUserType(response.data.userType, {expires: 1});
                    setUserFirstName(response.data.firstName, {expires: 1});
                    setUserLastName(response.data.lastName, {expires: 1});
                    closeModal();
                    navigation("/dashboard")
                }
                else {
                    setMessage(response.data.errorMessage)
                }
            });
    }

    const navigation = useNavigate();

    const closeModal = () => {
        setLogin(false);
    }


    return (

        <MDBModal staticBackdrop tabIndex='-1' show={isLogin}>
            <MDBModalDialog centered>
                <MDBModalContent>
                    <MDBModalHeader className="justify-content-center">
                        <MDBModalTitle>Login</MDBModalTitle>
                    </MDBModalHeader>
                    <MDBModalBody>
                        <div className={"text-danger my-2"}>
                            {message}
                        </div>
                        <div className="mb-3">
                            <MDBInput label='Email' id='typeEmail' type='email'
                                      onChange={(e) => setEmail(e.target.value)}
                                      className="form-control"
                            />
                        </div>
                        <div className="mb-3">
                            <MDBInput label='Password' id='typePassword' type='password'
                                      onChange={(e) => setPassword(e.target.value)}
                                      className="form-control"
                            />
                        </div>

                    </MDBModalBody>

                    <MDBModalFooter className="justify-content-center">
                        <MDBBtn variant="primary" active className="m-3" onClick={handleLogin}>Login</MDBBtn>
                        < MDBBtn variant="primary" active className="m-3" onClick={closeModal}>
                            Close
                        </ MDBBtn>
                    </MDBModalFooter>
                </MDBModalContent>
            </MDBModalDialog>
        </MDBModal>
    );
}

export default Login;
